const size = {
  xsmall: '320px',
  small: '480px',
  medium: '768px',
  large: '1024px',
  xlarge: '1200px'
};

export const breakpoint = {
  xsmall: `(min-width: ${size.xsmall})`,
  small: `(min-width: ${size.small})`,
  medium: `(min-width: ${size.medium})`,
  large: `(min-width: ${size.large})`,
  xlarge: `(min-width: ${size.xlarge})`
};
